import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconArrow = (props) => (
  <Icon fill="none" {...props}>
    <path
      d="M8.24585 1L22.3414 14.859L8 29"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
